const style = (theme) => {
  const output = {
    menuWrapper: {
      position: 'relative',
    },
    follow: {
      position: 'absolute',
      overflow: 'hidden',
      zIndex: 99,
      width: 360,
      height: 245,
      marginLeft: 0,
      opacity: 0,
      top: 0,
      left: 0,
      // top: '10%',
      // right: '25%',
      // marginTop: -30,
      // marginRight: -30,
      pointerEvents: 'none',
      '& img': {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        objectFit: 'cover',
        opacity: 0,
        height: '100%',
        width: '100%',
        willChange: 'opacity',
      },
    },
    // navItemWrapper: {
    //   '& a': {
    //     position: 'relative',
    //     fontSize: 80,
    //     fontFamily: theme.fonts[1],
    //     lineHeight: 1.1,
    //     textTransform: 'none',
    //     '& span': {
    //       pointerEvents: 'none',
    //       color: theme.colors[0],
    //       '-webkit-text-fill-color': 'transparent',
    //       '-webkit-text-stroke-width': '1px',
    //       '-webkit-text-stroke-color': theme.colors[0],
    //     },
    //     '&:after': {
    //       pointerEvents: 'none',
    //       color: theme.colors[0],
    //       '-webkit-text-fill-color': theme.colors[0],
    //       '-webkit-text-stroke': 'unset',
    //       position: 'absolute',
    //       // top: '-6px',
    //       // bottom: 0,
    //       left: 0,
    //       display: 'inline-block',
    //       overflow: 'hidden',
    //       width: '0%',
    //       whiteSpace: 'pre',
    //       content: 'attr(data-text)',
    //       transition: 'width 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.1s',
    //       willChange: 'width',
    //     },
    //     '&:hover': {
    //       '&:after': {
    //         width: 'calc(100% + 10px)',
    //         fallbacks: {
    //           width: '120%',
    //         },
    //       },
    //     },
    //   },
    //   '& .divider': {
    //     position: 'absolute',
    //     bottom: 15,
    //     left: 0,
    //     right: 0,
    //     width: '100%',
    //     height: 1,
    //     backgroundColor: theme.colors[4],
    //   },
    // },
    // navItemWrapperItemHover: {
    //   '& a': {
    //     color: theme.colors[4],
    //   },
    // },
    wrapperLink: {
      fontFamily: theme.fonts[1],
      color: theme.colors[1],
      fontSize: 80,
      position: 'relative',
      // '& svg': {
      //   position: 'absolute',
      //   top: 0,
      //   left: 0,
      //   width: '100%',
      //   height: '100%',
      //   pointerEvents: 'none',
      //   fill: 'transparent',
      //   strokeWidth: '1px',
      //   stroke: theme.colors[0],
      //   strokeDasharray: 1220,
      //   strokeDashoffset: 1220,
      //   transition: 'stroke-dashoffset 0.6s cubic-bezier(.455,.03,.515,.955)',
      //   '& path': {
      //     width: '100%',
      //     height: '100%',
      //   },
      // },
      // '&:hover svg': {
      //   strokeDashoffset: 0,
      // },
      '& p': {
        margin: 0,
        marginTop: 30,
        mixBlendMode: 'difference',
        position: 'relative',
        zIndex: 100,
      },
    },
    productHoverTrigger: {
      width: 'fit-content',
    },
  }

  output[theme.mediaInverse.sm] = {
    follow: {
      display: 'none',
    },
    menuLines: {
      flexDirection: 'column',
    },
    navItemWrapper: {
      display: 'block',
      '& .divider': {
        bottom: 8,
      },
    },
    wrapperLink: {
      fontSize: 38,
      '& svg': {
        display: 'none',
      },
    },
  }

  return output
}

export default style
